<template>
  <div class="border rounded overflow-hidden shadow">
    <div class="bg-white flex flex-col divide-y">
      <div class="inline-flex px-4 h-12 items-center space-x-2">
        <span class="inline-block truncate text-sm">
          {{ name }}
        </span>
      </div>
      <AssetableCover v-if="asset" :asset="asset" />
    </div>
  </div>
</template>

<script>
import AssetableCover from './AssetableCover.vue';

export default {
  components: {
    AssetableCover,
  },
  props: {
    projectAsset: {
      type: Object,
      required: true,
    },
    entities: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    asset() {
      return this.entities.assets[this.projectAsset.assetId];
    },
    media() {
      if (!this.asset?.media) {
        return null;
      }

      return this.entities.media[this.asset.media];
    },
    link() {
      if (!this?.asset?.link) {
        return null;
      }

      return this.entities.links[this.asset.link];
    },
    note() {
      if (!this?.asset?.note) {
        return null;
      }

      return this.entities.notes[this.asset.note];
    },
    name() {
      if (this.media) {
        return this.media.name;
      }

      if (this.link) {
        return this.link.title || this.link.url;
      }

      return 'Note';
    },
    url() {
      if (this.media) {
        return this.media.url;
      }

      if (this.link) {
        return this.link.url;
      }

      return '';
    },
  },
};
</script>
